import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './PasswordResetRequest.css';  // Import the CSS file

function ResetPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Handle the password reset request
  const handlePasswordResetRequest = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_FQDN}/api/request-password-reset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setMessage('Password reset email sent. Please check your inbox. If you cannot find it, please check the SPAM folder');
        setLoading(false);
      } else {
        const data = await response.json();
        setError(data.error || 'Failed to send reset email. Please try again.');
        setLoading(false);
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="reset-password-container">
      <div className="reset-password-box">
        <h2>Request Password Reset</h2>
        <p>If you don't see the email in your inbox, please check your spam folder and mark it as 'Not Spam.'</p>
        {error && <p className="reset-password-error-message">{error}</p>}
        {message && <p className="reset-password-success-message">{message}</p>}
        <form onSubmit={handlePasswordResetRequest}>
          <div className="reset-password-form-group">
            <label htmlFor="email" className="reset-password-label"></label>
            <input
              type="email"
              id="email"
              className="reset-password-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              autoComplete="email"
              required
              disabled={loading}
            />
            <button type="submit" className="reset-password-button" disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </div>
        </form>

        {loading && <div className="reset-password-spinner"></div>}

        <div className="reset-password-back-to-login">
          <Link to="/login">Go back to login</Link>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
